import Typography from '@mui/material/Typography'
import React from 'react'

const SnackbarComponent = ({
  title,
  message,
}: {
  title: string
  message: string
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="body1">{title}</Typography>
      <Typography variant="body2">{message}</Typography>
    </div>
  )
}

export default SnackbarComponent
